import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "cybersecurity-compliances-companies-in-hyderabad": {
    id: 1,
    title: "Cybersecurity compliances companies in hyderabad ",
    category: "Cybersecurity",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "August 12, 2026",
    author: "TechProjects",
    readTime: "10 minutes",
    excerpt:
      "Cybersecurity compliance companies in Hyderabad help businesses meet ISO 27001, NIST, GDPR, DORA and other security standards with expert compliance services.",
    content: [
      {
        type: "heading2",
        text: "Cybersecurity Compliance in 2026: How Companies Can Prepare for NIS2, DORA, ISO 27001 and AI Regulations",
      },
      {
        type: "paragraph",
        text: "Cybersecurity compliance has become a strategic business priority in 2026. Organizations are no longer concerned only about preventing cyberattacks; they must also demonstrate that their security controls, data governance, risk management and incident-response processes meet evolving regulatory and industry requirements.",
      },
      {
        type: "paragraph",
        text: 'For businesses operating in Hyderabad, this creates a growing need for reliable <a href="https://techprojects.com/Services/CSC" class="text-blue-600 hover:text-blue-800 font-semibold">cybersecurity compliance companies in Hyderabad</a> that can combine security technology, compliance frameworks, risk management and continuous monitoring.',
      },
      {
        type: "paragraph",
        text: "With Hyderabad emerging as a major technology hub for enterprises, startups and Global Capability Centers (GCCs), organizations increasingly need cybersecurity programs that can support both Indian and international regulatory requirements.",
      },
      {
        type: "heading2",
        text: "Why Cybersecurity Compliance Matters in 2026",
      },
      {
        type: "paragraph",
        text: "Modern businesses operate across cloud platforms, SaaS applications, remote work environments, AI systems and third-party technology ecosystems. This expanded digital environment creates additional cybersecurity and compliance risks.",
      },
      {
        type: "paragraph",
        text: "Companies must increasingly address:",
      },
      {
        type: "bulletList",
        items: [
        "Data protection and privacy",
        "Cybersecurity risk management",
        "Cloud security",
        "Identity and access management",
        "Third-party risk",
        "Security monitoring",
        "Incident response",
        "Business continuity",
        "AI governance",
        "Regulatory reporting",
        "Security audits and certifications"
      ],
      },
      {
        type: "paragraph",
        text: "Compliance should therefore not be treated as a one-time audit exercise. Businesses need continuous security monitoring and governance processes that evolve with their technology environment.",
      },
      {
  type: "heading2",
  text: "NIS2: A Major Cybersecurity Compliance Consideration",
},
{
  type: "paragraph",
  text: "The EU's NIS2 framework has increased expectations around cybersecurity risk management, incident handling, supply-chain security and organizational accountability.",
},
{
  type: "paragraph",
  text: "Companies in Hyderabad that provide technology, software, cloud, IT or business services to European organizations may need to understand how NIS2 requirements affect their operations and customer relationships.",
},
{
  type: "paragraph",
  text: "Organizations should assess:",
},
{
  type: "bulletList",
  items: [
    "Cybersecurity risk-management practices",
    "Incident detection and response",
    "Supplier and third-party security",
    "Vulnerability management",
    "Business continuity",
    "Access controls",
    "Security governance",
    "Incident reporting procedures"
  ],
},
{
  type: "paragraph",
  text: "A structured cybersecurity maturity assessment can help organizations identify gaps before they become compliance problems.",
},

{
  type: "heading2",
  text: "DORA and Financial Services Cybersecurity",
},
{
  type: "paragraph",
  text: "The Digital Operational Resilience Act (DORA) has made ICT risk management a major consideration for financial organizations operating in or serving the European market.",
},
{
  type: "paragraph",
  text: "Banks, financial institutions, fintech companies and relevant technology providers need stronger processes around ICT risk, incident management, resilience testing and third-party technology risk.",
},
{
  type: "paragraph",
  text: "For Hyderabad's growing financial-services and technology ecosystem, cybersecurity providers can help organizations strengthen controls around cloud infrastructure, applications, data and operational resilience.",
},

{
  type: "heading2",
  text: "ISO 27001 as a Foundation for Security Governance",
},
{
  type: "paragraph",
  text: "ISO/IEC 27001 remains one of the most widely recognized information-security management standards.",
},
{
  type: "paragraph",
  text: "Rather than viewing ISO 27001 simply as a certification requirement, organizations can use it as a framework for establishing a structured Information Security Management System (ISMS).",
},
{
  type: "paragraph",
  text: "An effective ISO 27001 program can include:",
},
{
  type: "numberedList",
  items: [
    "Information-security risk assessment",
    "Asset identification",
    "Security policies and procedures",
    "Access management",
    "Incident management",
    "Business continuity",
    "Supplier security",
    "Security awareness",
    "Internal audits",
    "Continuous improvement"
  ],
},
{
  type: "paragraph",
  text: 'For companies searching for <a href="https://techprojects.com/Services/CSC" class="text-blue-600 hover:text-blue-800 font-semibold">cybersecurity services in Hyderabad</a>, experience with structured security frameworks such as ISO 27001 can be an important selection criterion.',
},

{
  type: "heading2",
  text: "AI Regulations Are Changing Cybersecurity Compliance",
},
{
  type: "paragraph",
  text: "Artificial intelligence is introducing a new layer of cybersecurity and governance risk.",
},
{
  type: "paragraph",
  text: "Organizations are rapidly adopting generative AI, machine learning and AI-powered business applications. However, businesses must consider data protection, model security, access control, transparency, accountability and AI-related risks.",
},
{
  type: "paragraph",
  text: "AI governance should address questions such as:",
},
{
  type: "bulletList",
  items: [
    "What business data can employees provide to AI systems?",
    "Where is AI-generated or processed data stored?",
    "Who can access AI systems?",
    "Are sensitive datasets being exposed?",
    "How are AI vendors assessed?",
    "Are AI systems monitored for security risks?",
    "Are organizations maintaining appropriate audit trails?"
  ],
},
{
  type: "paragraph",
  text: "AI governance is becoming an important component of enterprise cybersecurity programs, particularly for organizations deploying AI at scale.",
},

{
  type: "heading2",
  text: "DPDP Compliance: An Important Priority for Indian Companies",
},
{
  type: "paragraph",
  text: "For businesses operating in India, the Digital Personal Data Protection (DPDP) framework is another important consideration.",
},
{
  type: "paragraph",
  text: "Recent reporting indicates that most DPDP provisions are expected to become applicable by May 2027, giving organizations a limited preparation window.",
},
{
  type: "paragraph",
  text: "Companies should begin evaluating:",
},
{
  type: "bulletList",
  items: [
    "What personal data they collect",
    "Why the data is collected",
    "Where the data is stored",
    "Who has access to it",
    "How consent is managed",
    "How data-security incidents are handled",
    "How vendors process personal information",
    "How data-related requests are managed"
  ],
},
{
  type: "paragraph",
  text: "Starting early can help businesses avoid rushed compliance projects as implementation deadlines approach.",
},
{
  type: "heading2",
  text: "How Companies Can Build a Cybersecurity Compliance Program",
},
{
  type: "paragraph",
  text: "A practical 2026 cybersecurity compliance strategy should follow a continuous improvement model.",
},

{
  type: "heading3",
  text: "Step 1: Conduct a Security and Compliance Gap Assessment",
},
{
  type: "paragraph",
  text: "Identify weaknesses across infrastructure, applications, data, policies, employees and third-party systems.",
},

{
  type: "heading3",
  text: "Step 2: Map Regulations to Security Controls",
},
{
  type: "paragraph",
  text: "Organizations should map requirements from relevant frameworks such as ISO 27001, NIS2, DORA and applicable Indian regulations to existing security controls.",
},

{
  type: "heading3",
  text: "Step 3: Strengthen Technical Security",
},
{
  type: "paragraph",
  text: "Implement appropriate controls covering:",
},
{
  type: "bulletList",
  items: [
    "Endpoint security",
    "Network security",
    "Cloud security",
    "Identity and access management",
    "Vulnerability management",
    "Encryption",
    "Security monitoring",
    "Backup and disaster recovery"
  ],
},

{
  type: "heading3",
  text: "Step 4: Establish Continuous Monitoring",
},
{
  type: "paragraph",
  text: "Security compliance should be monitored continuously rather than only before an audit. Security operations, vulnerability management and incident-response processes should operate throughout the year.",
},

{
  type: "heading3",
  text: "Step 5: Regularly Test and Improve",
},
{
  type: "paragraph",
  text: "Organizations should conduct security assessments, penetration testing, vulnerability assessments, incident-response exercises and compliance reviews to identify weaknesses.",
},
{
  type: "heading2",
  text: "Choosing Cybersecurity Compliance Companies in Hyderabad",
},
{
  type: "paragraph",
  text: "Businesses evaluating cybersecurity compliance companies in Hyderabad should look beyond basic security monitoring or compliance documentation.",
},
{
  type: "paragraph",
  text: "The right technology partner should ideally provide capabilities across:",
},
{
  type: "bulletList",
  items: [
    "Cybersecurity consulting",
    "Compliance assessment",
    "Risk management",
    "Cloud security",
    "Security operations",
    "Vulnerability management",
    "Incident response",
    "Identity security",
    "Data protection",
    "AI security and governance",
    "Continuous monitoring"
  ],
},
{
  type: "paragraph",
  text: "This integrated approach allows companies to connect cybersecurity operations with their compliance objectives.",
},
      {
        type: "heading2",
        text: "Why TechProjects Is a Strong Option for Cybersecurity Services in Hyderabad",
      },
      {
       type: "paragraph",
       text: '<a href="https://techprojects.com/" class="text-blue-600 hover:text-blue-800 font-semibold">TechProjects</a> is a technology consulting and transformation company with a Hyderabad presence and CyberSecurity & Compliance as one of its core service areas. Its broader capabilities include cybersecurity, cloud, AI, digital transformation and enterprise technology solutions.',
     },
    {
        type: "paragraph",
        text: "For organizations looking for cyber security services in Hyderabad, TechProjects can be positioned as a technology partner that combines security, compliance and digital transformation rather than treating cybersecurity as an isolated IT function."
    },
    {
        type: "paragraph",
        text: "Its security-focused capabilities are particularly relevant for organizations seeking to strengthen security governance, protect enterprise systems and prepare for evolving compliance requirements."
    },
      
        
      
      {
        type: "heading2",
        text: "Conclusion",
      },
      {
        type: "paragraph",
        text: "The rapid expansion of Global Capability Centers in Hyderabad reflects the city's growing importance as a global technology and innovation hub. U.S. companies are choosing Hyderabad because it offers a unique combination of skilled talent, cost efficiency, advanced infrastructure, and a thriving digital ecosystem.",
      },
      
      {
        type: "heading2",
        text: "Frequently Asked Questions (FAQs) :",
      },
      {
        type: "heading3",
        text: "1. What is cybersecurity compliance and why is it important for companies?",
      },
      {
        type: "paragraph",
        text: "Cybersecurity compliance means following applicable cybersecurity laws, regulations, standards, and industry requirements to protect business systems and sensitive data. It helps companies reduce cyber risks, avoid regulatory penalties, strengthen data protection, and build customer trust.",
      },
      {
        type: "heading3",
        text: "2. What cybersecurity compliance standards should companies follow in 2026?",
      },
      {
        type: "paragraph",
        text: "Depending on their industry and business operations, companies may need to follow standards and regulations such as ISO 27001, NIS2, DORA, SOC 2, GDPR, PCI DSS, NIST, and India's DPDP requirements.",
      },
      {
        type: "heading3",
        text: "3. How can companies prepare for NIS2, DORA, and ISO 27001 compliance?",
      },
      {
        type: "paragraph",
        text: "Companies should conduct a cybersecurity gap assessment, identify applicable requirements, implement appropriate security controls, strengthen risk management and incident response, document policies, and continuously monitor compliance.",
      },
      {
        type: "heading3",
        text: "4. How much do cybersecurity compliance services cost in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "Cybersecurity compliance costs in Hyderabad vary depending on company size, IT infrastructure, compliance requirements, security complexity, audit scope, and services required. A professional assessment is recommended to determine the appropriate investment.",
      },
      {
        type: "heading3",
        text: "5. How do I choose the best cybersecurity compliance company in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "Look for a provider with experience in cybersecurity consulting, ISO 27001, risk management, cloud security, vulnerability management, incident response, compliance assessments, and continuous security monitoring. TechProjects is a strong option for businesses seeking integrated cybersecurity and compliance services in Hyderabad.",
      },

    ],
    relatedArticles: [
      {
        title: "Cloud Migration Best Practices",
        image:
          "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
        category: "Cloud",
        slug: "cloud-migration-best-practices",
      },
      {
        title: "React Performance Optimization",
        image:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
        category: "React",
        slug: "react-performance-optimization",
      },
      {
        title: "DevOps Automation with CI/CD",
        image:
          "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
        category: "DevOps",
        slug: "devops-automation-cicd",
      },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  // useEffect(() => {
  //   const fetchMetaData = async () => {
  //     const data = await getPagesBySlug(slug);
  //     setMetaData(data?.meta || {});
  //   };
  //   fetchMetaData();
  // }, [slug]);
  // slug = useParams();
 useEffect(() => {
  const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };

      fetchData();},[slug]);
  // console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["cybersecurity-compliances-companies-in-hyderabad"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Cybersecurity compliance companies in Hyderabad help businesses meet ISO 27001, NIST, GDPR, DORA and other security standards with expert compliance services.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
